<template>
    <span v-if="showFormattedAmount"
          class="price">
        <span class="font-numbers">{{ amountText }}</span>
        <span v-if="postfix === '€'"
              class="currency-eur">{{ postfix }}</span>
        <span v-else
              class="font-numbers">{{ postfix }}</span>
    </span>

    <template v-else>
        {{ amountText }}
    </template>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref } from 'vue';
import { AmountViewObject } from '@/api/checkout';
import { formatAmount } from '@/project/intl/amountFormatter';
import { getCultureSettings } from '@/project/content/api/contentApi';

export default defineComponent({
    name: 'Price',
    props: {
        amount: { required: true, type: Object as PropType<AmountViewObject | null | undefined> },
        currency: { required: false, type: String, default: '' },
        showFormattedAmount: { type: Boolean },
    },
    setup(props) {
        const culture = ref('');
        const postfix = ref('€');

        getCultureSettings().then((settings) => {
            culture.value = settings.culture;
            postfix.value = settings.pricePostfix?.length ? settings.pricePostfix : ',-';
        });

        const amountText = computed(() => {
            return props.showFormattedAmount
                ? (props.amount?.formatted ?? '')
                : props.amount?.value
                    ? formatAmount(culture.value, props.amount.value, props.currency)
                    : '';
        });

        return { amountText, postfix };
    },
});
</script>

<style scoped>
.price{
  display: inline-flex;
  align-items: baseline; /* key part */
  gap: 0; /* tweak if you want a space */
}

.font-numbers{
  font-family: normal_numbers;
}

.currency-eur{
  font-family: Arial, sans-serif;
  font-weight: 700;      /* optional */
  line-height: 1;        /* helps avoid extra vertical drift */
  font-size: 0.9em;      /* tweak to visually match your digits */
  /* margin-left: .05em;  optional tiny spacing */
}
</style>
